import React from "react";
import Grid from "@mui/material/Grid";
import { Box } from "@mui/system";
import { NavLink, useNavigate, useLocation } from "react-router-dom";
import {
  Stack,
  Fade,
  IconButton,
  Menu,
  MenuItem,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import Link from "@mui/material/Link";
import { SecondaryButton } from "components/common/button/Button";
import logo from "assets/images/vds-logo.png";
import { loginUrl } from "common/constants/apiUrls";
import { useAuth } from "hooks/authentication/useAuth";
import { fetchProfile } from "services/FetchProfile";
import { usePermission } from "hooks/permission/usePermission";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

const Navbar = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const auth = useAuth();
  const { setPermissions } = usePermission();
  const fetchUserProfile = async () => {
    const { route } = await fetchProfile(auth, setPermissions);
    if (route) {
      navigate(route);
    } else {
      window.location = "/login";
    }
  };
  const LanguageDropDown = () => {
    const [anchorEll, setAnchorEll] = React.useState(null);
    const open = Boolean(anchorEll);

    const handleClick = (event) => {
      setAnchorEll(event.currentTarget);
    };
    const handleClose = () => {
      setAnchorEll(null);
    };
    const languageChanger = async (event) => {
      let key = event.target.value;
      i18next.changeLanguage(key);
      localStorage.setItem("LanguagePreference", JSON.stringify(key));
      handleClose();
    };
    return (
      <>
        <div>
          <label
            style={{
              textTransform: "uppercase",
              cursor: "pointer",
              fontWeight: "bold",
              marginLeft: "1rem",
            }}
          >
            {i18next.language}
          </label>
          <IconButton
            sx={{
              cursor: "pointer",
            }}
            aria-label="logout menu"
            size="small"
            aria-controls={open ? "fade-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
          >
            <img src="/assets/icons/down-arrow.png" alt="open" />
          </IconButton>
        </div>
        <Menu
          PaperProps={{
            elevation: 2,
            sx: {
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.09))",
              mt: 2,
              borderRadius: "8px !important",
            },
          }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          id="fade-menu"
          MenuListProps={{
            "aria-labelledby": "fade-button",
          }}
          anchorEl={anchorEll}
          open={open}
          onClose={handleClose}
          TransitionComponent={Fade}
        >
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            defaultValue="female"
            name="radio-buttons-group"
            onChange={languageChanger}
            value={i18next.language}
            sx={{
              paddingLeft: "1rem",
            }}
          >
            <FormControlLabel value="de" control={<Radio />} label="Deutsch" />
            <FormControlLabel value="en" control={<Radio />} label="English" />
          </RadioGroup>
        </Menu>
      </>
    );
  };
  return (
    <Grid
      display="flex"
      justifyContent="start"
      container
      sm={{ color: "color.blueLight" }}
      className="navbar"
    >
      <Grid
        item
        md={6}
        sm={12}
        xs={12}
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
        }}
      >
        <Box
          className="left-sub-nav"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "30%",
          }}
          onClick={() => navigate("/")}
        >
          <img style={{ cursor: "pointer" }} src={logo} />
        </Box>
        <Box className="left-nav">
          <NavLink to="/gecco" className="Linknav">
            Gecco
          </NavLink>
          <NavLink to="/futurecare" className="Linknav">
            FutureCare
          </NavLink>
          <NavLink to="/digitalsolution" className="Linknav">
            DigitalSolutions
          </NavLink>
        </Box>
      </Grid>
      <Grid md={5} sm={12} xs={12}>
        <Box
          className="right-nav"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            width: "100%",
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: "220px",
              display: "flex",
              justifyContent: "end",
              padding: "20px 10px",
            }}
          >
            <SecondaryButton
              title={auth.user ? t("start") : t("login")}
              variant="dark"
              click={() => {
                if (auth.user) {
                  fetchUserProfile();
                } else navigate("/login");
              }}
            />
          </Box>
          <LanguageDropDown />
        </Box>
      </Grid>
    </Grid>
  );
};

export default Navbar;
